// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__HgqBa","checkboxCol":"Table_checkboxCol__31bx_","emailCol":"Table_emailCol__EvOfc","actionCol":"Table_actionCol__3d8AZ"};